import { DisplayCardContainer } from '@aon/aon-tws-common-ui';
import React from 'react';
import { AdminHelper, AudienceAdminCardType } from '../../../../utilities/AdminHelper';

export const AudienceAdminMenuContent = (props: { surveyId: number; audienceId: number; handleCancelEventClick: () => void }) => {
	return <DisplayCardContainer>{getAdminCards()}</DisplayCardContainer>;

	function getAdminCards() {
		const adminCards = [
			AudienceAdminCardType.OpenClose,
			AudienceAdminCardType.InviteEmail,
			AudienceAdminCardType.ReminderEmail,
			AudienceAdminCardType.ParticipationMonitor,
			AudienceAdminCardType.DistributionList,
			AudienceAdminCardType.HierarchyView,
			AudienceAdminCardType.ResetReopenResend,
			AudienceAdminCardType.SurveyUrlsList,
			AudienceAdminCardType.CancelEvent,
			AudienceAdminCardType.ReopenSurvey,
		];

		return AdminHelper.AudienceAdminCards({
			surveyId: props.surveyId,
			audienceId: props.audienceId,
			cards: adminCards,
			handleCancelEventClick: props.handleCancelEventClick,
		});
	}
};
